import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';

const options = {
  name: 'applications-card',
};

const useStyles = makeStyles(
  (theme: Theme) => ({
    root: {
      maxWidth: theme.spacing(45),
      padding: theme.spacing(3),
      border: `1px solid ${theme.palette.grey[100]}`,
      borderRadius: theme.spacing(1),
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
    },
    header: {},
    statuses: {},
    additional: {},
    body: {
      marginBottom: 'auto',
    },
    footer: {},
    date: {},
    link: {
      cursor: 'pointer',
    },
  }),
  options
);

export default useStyles;
